import { render } from "./cadastro_acessorio.vue?vue&type=template&id=d45c0c74&scoped=true"
import script from "./cadastro_acessorio.vue?vue&type=script&lang=js"
export * from "./cadastro_acessorio.vue?vue&type=script&lang=js"

import "./cadastro_acessorio.vue?vue&type=style&index=0&id=d45c0c74&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d45c0c74"]])

export default __exports__